export const CHATBOT_ACTION = {
  CHECK_ALARMS: "CHECK_ALARMS",
};
